/**
 * Central image imports for consistent usage across the app
 * Using static imports ensures proper optimization and no 400 errors
 */

// Logo variants
import starBall from '../../../public/logos/star_ball.png';
import starBallFinal from '../../../public/logos/star_ball_final.png';
import starBallV2 from '../../../public/logos/star_ball_v2.png';
import ballOnly from '../../../public/logos/BallOnly.png';
import voleyT from '../../../public/logos/voleyT.png';

// Partner logos
import hawkSoftLogo from '../../../public/logos/HawkSoft_logo_long.png';
import hawkSoftIncLogo from '../../../public/logos/hawksoft_inc_logo.jpg';
import agencyZoomLogo from '../../../public/logos/agencyzoom_long.png';
import zapierLogo from '../../../public/logos/zapierlogo.png';


export const logos = {
  // Main logo variants
  starBall,
  starBallFinal,
  starBallV2,
  ballOnly,
  voleyT,

  // Partner logos
  hawkSoft: hawkSoftLogo,
  hawkSoftInc: hawkSoftIncLogo,
  agencyZoom: agencyZoomLogo,
  zapier: zapierLogo,
};

// Default logo export for convenience
export default logos.starBall;